module.exports = __webpack_public_path__ + "html/editable_db996aafcea7c65151268513181eb155.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/editable.html
// module id = GgDZ
// module chunks = 154